import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class BuyerBOEService {

  constructor(private http: Http, private router: Router) { }


  public filterBOE(buyerBOEID: any) {
    console.log('inside services');
    const BOEId = buyerBOEID;
    return this.http.get(environment.baseUrl + '/buyer/boe/' + BOEId,
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public  OnBOEUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('BOEsellerId');
    const manualInvoiceFlag = sessionStorage.getItem('invoiceFlag');
    const formData: FormData = new FormData();
    formData.append('billOfExchange', Image);
    formData.append('invoiceId', fileId);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post( environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public getBOEHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('buyerBOECustomerId');
    const BOEinvoiceFlag = sessionStorage.getItem('buyerBOEinvoiceFlag');
    return this.http.get( environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + BOEinvoiceFlag + '/billOfExchange',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public getLRHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('buyerLRCustomerId');
    const LRinvoiceFlag = sessionStorage.getItem('buyerLRinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + LRinvoiceFlag + '/lorryReceipt',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
}
